export interface Status {
    id: number,
    project_id: number,
    state: number,
    definition: string,
    color: string | null,
    created: string,
    modified: any,
    removed: any
    type: number | null
    name: string;
}

export interface WorkOrderStatus {
  key?: string;
  color: string;
  definition: string;
  id: number;
  show: boolean;
  state: number;
  type: number;
  workorders: {
    amount: number;
    done: number;
    doneids: number[];
    interruptedids?: number[];
    doneidsmap?: Map<number, boolean>;
    interruptedidsmap?: Map<number, boolean>;
    interrupted: number;
    scheduled: number;
    scheduledtothisday: number;
    todaydone: number;
    todayinterrupted: number;
    todaytotal: number;
    totaldone: number;
    totalinterrupted: number;
    totaltotal: number;
    weekdone: number;
    weekinterrupted: number;
    weektotal: number;
  };
}

export enum StatusDefinitions {
  NOT_STARTED = 'NOT_STARTED',
  REMARKS = 'REMARKS',
  DONE = 'DONE',
}
